import type { BoxProps } from '@mantine/core';
import { Box, createStyles } from '@mantine/core';
import { memo } from 'react';
import { DOCUMENTATION_WIDTH } from '../../../components/Documentation/constants';

const useStyles = createStyles((theme) => ({
	wrapper: {
		width: '100%',
		maxWidth: `calc(${DOCUMENTATION_WIDTH}px + (2 * 1.5rem))`,
		margin: '0 auto',
		paddingLeft: theme.spacing.xl,
		paddingRight: theme.spacing.xl,
		position: 'relative',

		[theme.fn.smallerThan('md')]: {
			maxWidth: '100%',
		},
	},
}));

export const AiViewportWrapper = memo(({ children, ...props }: BoxProps) => {
	const { classes } = useStyles();

	return (
		<Box className={classes.wrapper} {...props}>
			{children}
		</Box>
	);
});
